import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSettings } from 'services/settings/SettingsContext';
import { ListColumnType } from 'types/ListTypes';
import { formatDateString } from 'services/utils/dateTimeUtils';
import AbstractList from 'components/lists/AbstractList';
import ReleaseForm from './ReleaseForm';
import ReleaseEditForm from './ReleaseEditForm';

// Rename the name of the function:
const ReleaseList: React.FC = () => {
    const { t } = useTranslation();
    const { userLocale } = useSettings();

    // Specify the options of this list:
    const query = {
        endpoint: 'get_release_list',
        object: 'release'
    }
    const objectName = 'release.general.object_name'
    const showSearch = false
    const showDeleteOrDeactivate = 'flag_deleted'

    // Set isPaginated to true if this list may have 100.000+ items:
    const isPaginated = false

    // Specify form, detail modal or detailpage for this list
    const formModal = <ReleaseForm />;
    const detailModal = <ReleaseEditForm />;
    const onRowClick = 'detailModal'
    const detailModalSize = 'medium'

    // Put the version, date and state in the same value
    const renderCombinedValue = (version: string, dateString: string, status: string) => {
        // Format the date
        const formattedDate = formatDateString(dateString, userLocale);

        // Configure the combined value
        let combinedValue;
        if (status === 'draft') {
            combinedValue = <>{version} - {formattedDate} - ({t('release.general.draft_release_label')})</>
        } else {
            combinedValue = <>{version} - {formattedDate}</>
        }

        return combinedValue;
    };

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        { 
            width: '1fr', 
            field: 'version', 
            label: 'release.general.version_label',
            render: (_, row) => renderCombinedValue(row.version, row.release_date, row.status)
        }
    ];

    return (
        <AbstractList
            query={query}
            objectName={objectName}
            columns={columns}
            showSearch={showSearch}
            showDeleteOrDeactivate={showDeleteOrDeactivate}
            formModal={formModal}
            detailModal={detailModal}
            detailModalSize={detailModalSize}
            isPaginated={isPaginated}
            onRowClick={onRowClick}
        />
    );
};

export default ReleaseList;